// extracted by mini-css-extract-plugin
export default {"icon":"ConfirmModal_icon__PouxV"};